// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"530":"d6a08b55","729":"4191d24b"}[chunkId] + ".chunk.js";
};